import { useTranslation } from 'react-i18next';
import { TableCell } from '@mui/material';
import { icons } from '@shared/static/icons';
import { useEditCardDialog } from '@utils/dialogs-hooks';

export default function NoteCell({ row }) {
  const { openEditCardDialog } = useEditCardDialog();
  const { t } = useTranslation();
  return (
    <TableCell>
      <div className="noteCell">
        <button
          className={row.note ? 'dashed-btn noteCell__content' : 'dashed-btn'}
          onClick={(e) => {
            e.stopPropagation();
            openEditCardDialog(row);
          }}
        >
          {row.note ? icons.edit : icons.add}
          <p className="fw-500">{row.note || t('add')}</p>
        </button>
      </div>
    </TableCell>
  );
}
